import { ProductDesign, ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import addFrameWithDoorStyle from 'rangeConfig/pax/behaviors/addFrameWithDoorStyle';
import { filterCornerSolutions } from 'rangeConfig/pax/filters/mainMenuProductFilters';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';

const framesProductListConfig = (): ProductListConfig => {
  return {
    cardsTitle: '',
    cardsSubtitle:
      'communicatedDimensionsLocalized.width communicatedDimensionsLocalized.unit storageone.productCardTextWide',
    infoButtonAriaLabel:
      'storageone.frame communicatedDimensionsLocalized.width communicatedDimensionsLocalized.unit storageone.productCardTextWide',
    productFilters: [filterCornerSolutions],
    cluster: [],
    behaviors: {
      productClicked: [addFrameWithDoorStyle],
      productDropped: [addProduct]
    },
    sortOrder: [{ path: 'communicatedDimensions.depth' }, { path: 'communicatedDimensions.width' }],
    categories: [
      {
        id: 'white',
        categoryTitle: 'designText',
        products: [
          { path: 'type', value: ProductType.PAX_FRAME },
          { path: 'type', value: ProductType.PAX_CORNER_SOLUTION_ASM },
          { path: 'design', value: ProductDesign.WHITE }
        ]
      },
      {
        id: 'wso',
        categoryTitle: 'designText',
        products: [
          { path: 'type', value: ProductType.PAX_FRAME },
          { path: 'type', value: ProductType.PAX_CORNER_SOLUTION_ASM },
          { path: 'design', value: ProductDesign.WHITE_STAINED_OAK }
        ]
      },
      {
        id: 'black',
        categoryTitle: 'designText',
        products: [
          { path: 'type', value: ProductType.PAX_FRAME },
          { path: 'type', value: ProductType.PAX_CORNER_SOLUTION_ASM },
          { path: 'design', value: ProductDesign.BLACK_BROWN }
        ]
      },
      {
        id: 'bsa',
        categoryTitle: 'designText',
        products: [
          { path: 'type', value: ProductType.PAX_FRAME },
          { path: 'type', value: ProductType.PAX_CORNER_SOLUTION_ASM },
          { path: 'design', value: ProductDesign.BROWN_STAINED_ASH }
        ]
      },
      {
        id: 'gsa',
        categoryTitle: 'designText',
        products: [
          { path: 'type', value: ProductType.PAX_FRAME },
          { path: 'type', value: ProductType.PAX_CORNER_SOLUTION_ASM },
          { path: 'design', value: ProductDesign.GREY_STAINED_ASH }
        ]
      },
      {
        id: 'dgrey',
        categoryTitle: 'designText',
        products: [
          { path: 'type', value: ProductType.PAX_FRAME },
          { path: 'type', value: ProductType.PAX_CORNER_SOLUTION_ASM },
          { path: 'design', value: ProductDesign.DARK_GREY }
        ]
      },
      {
        id: 'beige',
        categoryTitle: 'designText',
        products: [
          { path: 'type', value: ProductType.PAX_FRAME },
          { path: 'type', value: ProductType.PAX_CORNER_SOLUTION_ASM },
          { path: 'design', value: ProductDesign.BEIGE }
        ]
      }
    ]
  };
};

export default framesProductListConfig;
